import { render, staticRenderFns } from "./DialogProfileUserChangePassword.vue?vue&type=template&id=54609a92&"
import script from "./DialogProfileUserChangePassword.vue?vue&type=script&lang=js&"
export * from "./DialogProfileUserChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./DialogProfileUserChangePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54609a92')) {
      api.createRecord('54609a92', component.options)
    } else {
      api.reload('54609a92', component.options)
    }
    module.hot.accept("./DialogProfileUserChangePassword.vue?vue&type=template&id=54609a92&", function () {
      api.rerender('54609a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogProfileUserChangePassword.vue"
export default component.exports